import * as React from 'react';
import type { SVGProps } from 'react';
const SvgSetting = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 20 21"
    {...props}
  >
    <path d="M15.713 5.107h-1.27a2.75 2.75 0 0 0-2.305-1.25c-.966 0-1.815.497-2.305 1.25H4.5a1.5 1.5 0 0 0 0 3h5.333a2.748 2.748 0 0 0 4.61 0h1.27a1.5 1.5 0 0 0 0-3m-9.162 7.522a2.75 2.75 0 0 1 2.306-1.25c.965 0 1.814.497 2.305 1.25h4.551a1.5 1.5 0 0 1 0 3h-4.551a2.75 2.75 0 0 1-2.305 1.25 2.75 2.75 0 0 1-2.306-1.25H4.5a1.5 1.5 0 0 1 0-3z" />
  </svg>
);
export default SvgSetting;
